import { Helmet } from "react-helmet";

const ContactUs = () => {
  return (
    <>
        <Helmet>
            <title>Contact Us | Freelity</title>
            <meta
            name="description"
            content="Contact Freelity for support, feedback, or suggestions. Reach us via email or phone."
            />
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href="https://freelity.com/contact" />
        </Helmet>
         <section className="sec-free-tools termsconditions">
            <div className="container">
                <h1 className="text-center">Contact Us</h1>

                <p className="text-center myclass">
                    Have questions or feedback? Reach out to us anytime using the information below.
                </p>

                <div className="row justify-content-center">
                    <div className="col-md-8 box-shadow">
                        <div className="location-box">
                            <div className="">
                                <h5>Email Address :</h5>
                                <a href="mailto:support@freelity.com" className="blackclr">support@freelity.com</a>
                            </div>

                            <div className="">
                                <h5>Phone Number :</h5>
                                <a href="tel:+919569333952" className="blackclr">+91 956-9333-952</a>
                            </div>

                            <div className="">
                                <h5>Address :</h5>
                                <p>Bhucho Mandi, Bathinda, Punjab</p>
                            </div>
                        </div>

                        <hr />

                        <h4 className="mb-3">Send Us a Message</h4>

                       <form action="https://formspree.io/f/mdkgbeld" method="POST">
                            <div className="mb-3">
                            <label className="form-label">
                                Name
                            </label>
                            <input
                                type="name"
                                name="name"
                                className="form-control"
                                placeholder="Enter Name"
                                required
                            />
                            </div>

                            <div className="mb-3">
                            <label className="form-label">
                                Email
                            </label>
                            <input
                                type="email" 
                                name="email"
                                className="form-control"
                                placeholder="Enter Email"
                                required
                            />
                            </div>

                            <div className="mb-3">
                            <label className="form-label">
                                Message
                            </label>
                            <textarea
                                name="message"
                                rows="5"
                                className="form-control"
                                 placeholder="Enter Your message..."
                                required
                            ></textarea>
                            </div>

                            <div className="text-end">
                                <button type="submit" className="btn btn-primary">
                                    Send Message
                                </button>
                            </div>
                        </form>

                        {/* <p className="mt-3 text-muted">
                            * This form uses Formspree to send messages directly to your email without a backend.
                        </p> */}
                    </div>
                </div>
            </div>
        </section>
    </>
  );
};

export default ContactUs;
